/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { postEveUomRequestAsync } from './DataActionExtension.g';
import { IEveEachPrice, IEveEachPriceRequestMap } from './DataServiceEntities.g';

/**
 * GetUom Input Action
 */
export class GetUomInput implements Msdyn365.IActionInput {
    public reqMap: IEveEachPriceRequestMap[];
    public catalogId: string | number;
    // TODO: Construct the input needed to run the action
    constructor(itemIds: IEveEachPriceRequestMap[], catalogId: string | number) {
        this.reqMap = itemIds;
        this.catalogId = catalogId;
    }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ITEMIDS:${this.reqMap.map(i => i.ProductItemId).join(';')}:CATID:${this.catalogId}`;
    public getCacheObjectType = () => 'UnitOfMeasure';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetUomData {
    prices: IEveEachPrice[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetUomInput([], 0);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetUomInput, ctx: Msdyn365.IActionContext): Promise<IEveEachPrice[]> {
    return postEveUomRequestAsync({ callerContext: ctx }, input.reqMap, +input.catalogId);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IEveEachPrice[]>>action,
    // TODO: Give your data action a unique id
    id: 'GetUom',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
